import { Payload } from "@neworbit/redux-helpers";
import { Dispatch } from "redux";
import axios from "axios";

import { loadAndTrack } from "redux-request-loading";

import { AllowedAssessmentAndWellBeingFeaturesApi } from "./AllowedAssessmentAndWellBeingFeaturesApi";
import * as actionTypes from "./actionTypes";

type LoadAllowedAssessmentAndWellBeingFeaturesSuccessAction =
    { type: typeof actionTypes.LOAD_ALLOWED_ASSESSMENT_AND_WELL_BEING_FEATURES_SUCCESS } & Payload<string[]>;

export type AllowedAssessmentAndWellBeingFeaturesAction = LoadAllowedAssessmentAndWellBeingFeaturesSuccessAction;

function buildLoadAllowedAssessmentAndWellBeing9Features(allowedAssessmentAndWellBeingFeaturesApi: AllowedAssessmentAndWellBeingFeaturesApi) {
    return () => {
        return async (dispatch: Dispatch) => {
            const result = await loadAndTrack(
                dispatch,
                actionTypes.LOAD_ALLOWED_ASSESSMENT_AND_WELL_BEING_FEATURES,
                allowedAssessmentAndWellBeingFeaturesApi.load());
            dispatch(loadAllowedAssessmentAndWellBeingFeaturesSuccess(result));
        };
    };
}

export const loadAllowedAssessmentAndWellBeingFeatures =
    buildLoadAllowedAssessmentAndWellBeing9Features(new AllowedAssessmentAndWellBeingFeaturesApi(axios));

export function loadAllowedAssessmentAndWellBeingFeaturesSuccess(
    allowedAssessmentAndWellBeingFeatures: string[]): LoadAllowedAssessmentAndWellBeingFeaturesSuccessAction {
    return {
        type: actionTypes.LOAD_ALLOWED_ASSESSMENT_AND_WELL_BEING_FEATURES_SUCCESS,
        payload: allowedAssessmentAndWellBeingFeatures
    };
}
